import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { APP_PATHS } from '@/app/utils';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return router.createUrlTree([APP_PATHS.HOME]);
  }

  return authService.tryRestoreSession().pipe(
    map((restored) => (restored ? router.createUrlTree([APP_PATHS.HOME]) : true))
  );
};
